import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SelectedGroup from './GroupsChooserSelectedGroup';

function GroupsChooserSelectedBox({ className, selectedGroups, isUnavailable, onGroupDelete }) {
    return (
        <div className={`${className} selected-groups`}>
            {!selectedGroups.length && (
                <div className="selected-groups__content selected-groups__content--empty">
                    {getEmptyMessage(isUnavailable)}
                </div>
            )}
            {!!selectedGroups.length && (
                <ul className="selected-groups__content selected-groups__list">
                    {selectedGroups.map((group) => (
                        <SelectedGroup
                            className="selected-groups__list-item"
                            key={group.id}
                            group={group}
                            onDelete={onGroupDelete}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
}

function getEmptyMessage(isUnavailable) {
    if (isUnavailable) {
        return (
            <>
                <i className="fa fa-exclamation-triangle selected-groups__empty-ico" />
                Groups are currently unavailable.
            </>
        );
    }

    return (
        <>
            <i className="fa fa-users selected-groups__empty-ico" />
            No groups added.
        </>
    );
}

GroupsChooserSelectedBox.propTypes = {
    className: PropTypes.string,
    isUnavailable: PropTypes.bool.isRequired,
    selectedGroups: PropTypes.array.isRequired,
    onGroupDelete: PropTypes.func.isRequired,
};

export default GroupsChooserSelectedBox;
